// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__rldOd","inputDescription":"styles_inputDescription__3XsOk"};